import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import ReactPlayer from "react-player";
import VimeoPlayer from "react-player";

const Video = (props) => {
  const {
    autoplay,
    background,
    containerClassName,
    controls,
    light,
    loop,
    muted,
    portrait,
    progressInterval,
    video,
    videoYoutubeUrl,
    videoRef,
  } = props;

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  useEffect(() => {
    const handleActivityFalse = () => {
      setIsVideoPlaying(false);
    };

    const handleActivityTrue = () => {
      setIsVideoPlaying(true);
      videoRef?.play();
    };

    if (typeof window !== "undefined") {
      window.addEventListener("focus", handleActivityTrue);
      window.addEventListener("blur", handleActivityFalse);
      window.addEventListener("resize", handleActivityTrue);
    }

    return () => {
      // Remove event listener so we arent checking forever
      if (typeof window !== "undefined") {
        window.removeEventListener("focus", handleActivityTrue);
        window.removeEventListener("blur", handleActivityFalse);
        window.removeEventListener("resize", handleActivityTrue);
      }
    };
  }, []);

  return (
    <div className={`player-wrapper ${containerClassName}`}>
      {!videoYoutubeUrl && video?.vimeo_raw && (
        <VimeoPlayer
          onReady={props.onVideoReady}
          onPlay={props.onVideoPlay}
          onEnded={props.onVideoEnded}
          onProgress={props.onVideoProgress}
          playing={isVideoPlaying}
          ref={videoRef}
          url={video?.vimeo_raw}
          light={light}
          width="100%"
          height="100%"
          playsinline={true}
          playsInline
          progressInterval={progressInterval}
          loop={loop}
          controls={controls}
          config={{
            vimeo: {
              playerOptions: {
                dnt: true,
                portrait,
                responsive: true,
                playsinline: true,
                controls,
                autoplay,
                loop,
                background,
                muted,
              },
            },
          }}
        />
      )}
      {videoYoutubeUrl && (
        <ReactPlayer
          onReady={props.onVideoReady}
          onPlay={props.onVideoPlay}
          onEnded={props.onVideoEnded}
          onProgress={props.onVideoProgress}
          playing={isVideoPlaying}
          ref={videoRef}
          light={light}
          width="100%"
          height="100%"
          playsinline={true}
          playsInline
          loop={loop}
          controls={controls}
          url={videoYoutubeUrl}
          config={{
            youtube: {
              playerVars: {
                dnt: true,
                portrait,
                responsive: true,
                playsinline: true,
                controls,
                autoplay,
                loop,
                background,
                muted,
              },
            },
          }}
        />
      )}
    </div>
  );
};

export default Video;

Video.propTypes = {
  autoplay: PropTypes.bool,
  containerClassName: PropTypes.string,
  controls: PropTypes.bool,
  light: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  portrait: PropTypes.bool,
  video: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

Video.defaultProps = {
  autoplay: true,
  background: false,
  containerClassName: "",
  controls: false,
  light: false,
  loop: false,
  muted: false,
  portrait: false,
  video: null,
};
